var React = require('react');

function QuoteLeft (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},".st0{fill-rule:evenodd;clip-rule:evenodd;}"),React.createElement("g",{"key":1},React.createElement("path",{"className":"st0","d":"M106.97,92.81H84.89c-8.5,0-15.45-6.95-15.45-15.45c0-31.79-8.12-66.71,30.84-76.68 c17.65-4.51,22.25,14.93,3.48,16.27c-11.45,0.82-13.69,8.22-14.04,19.4h17.71c8.5,0,15.45,6.95,15.45,15.45v25.09 C122.88,85.65,115.72,92.81,106.97,92.81L106.97,92.81z M38.23,92.81H16.15c-8.5,0-15.45-6.95-15.45-15.45 c0-31.79-8.12-66.71,30.84-76.68C49.2-3.84,53.8,15.6,35.02,16.95c-11.45,0.82-13.69,8.22-14.04,19.4H38.7 c8.5,0,15.45,6.95,15.45,15.45v25.09C54.14,85.65,46.98,92.81,38.23,92.81L38.23,92.81z"}))]);
}

QuoteLeft.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 122.88 92.81","style":{"enableBackground":"new 0 0 122.88 92.81"},"xmlSpace":"preserve"};

module.exports = QuoteLeft;

QuoteLeft.default = QuoteLeft;
